import React from "react";
import { FieldRendererProps } from "../types";
import { CheckboxGroup } from "../../../ui/index.ts";
import {
    applyNoneExclusiveCheckboxChange,
    findNoneOptionValue,
} from "../checkbox-none-exclusive.ts";
import styles from "./shared.module.css"
import clsx from "clsx";

export default function CheckboxFieldRenderer({ question, field, readOnly, index }: FieldRendererProps) {
    const rawOptions = JSON.parse(question.optionsJson ?? "[]");
    const formattedValues = rawOptions.map((opt: any) => ({
        value: String(opt),
        label: String(opt),
    }));

    if (readOnly) {
        return <div className={styles.wrapper}>
            <label className={clsx(
                "sub-heading-md",
                styles.label)} htmlFor={field.name}>{question.question}</label>
            <div className={clsx("body-sm", styles.checkboxValues)}>{field.state.value.map((answer) => <span className={clsx("body-sm", styles.checkboxValue)}>{answer}</span>)}</div>
        </div>;
    }

    const label = (index ?? false) !== false ? `${index}.  ${question.question}` : question.question;
    const prev = field.state.value as string[];
    return <CheckboxGroup
        name={field.name}
        id={field.name}
        label={label}
        value={field.state.value}
        onChange={(next) =>
            field.handleChange(
                applyNoneExclusiveCheckboxChange(
                    prev,
                    next,
                    findNoneOptionValue(formattedValues),
                ),
            )
        }
        onBlur={field.handleBlur}
        error={field.state.meta.errors?.[0]?.message?.toString()}
        options={formattedValues}
        disabled={readOnly}
    />;
}